import { dataCalendarCnySolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCalendarCnySolid = /*#__PURE__*/createIcon(dataCalendarCnySolid)
export default IconCalendarCnySolid
